var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"to-top-btn",on:{"click":_vm.backToTop}},[_c('v-icon',{attrs:{"name":"angle-up","aria-hidden":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }